import App from 'app/app.js';
import 'app/action/ResetJobAction.js';

function ProgressStepperStore($filter) {
  // var cartPage =  $filter('ltTranslateFilter')('CART_PROGRESS_STEP');
  // var shippingPage = $filter('ltTranslateFilter')('SHIPPING_PROGRESS_STEP', {});
  // var paymentPage =  $filter('ltTranslateFilter')('PAYMENT_PROGRESS_STEP', {});
  // var reviewOrderpge =  $filter('ltTranslateFilter')('REVIEW_PROGRESS_STEP', {});

  this.cartPage = 'Cart';
  this.shippingPage = 'Shipping';
  this.paymentPage = 'Payment';
  this.reviewOrderpage = 'ReviewOrder';

  this.progressStatus = {};

  this.progressStatus[this.cartPage] = false;
  this.progressStatus[this.shippingPage] = false;
  this.progressStatus[this.paymentPage] = false;
  this.progressStatus[this.reviewOrderpage] = false;

  this.setCompletedstatus = function (page) {
    this.progressStatus[page] = true;
  };

  this.setIncompleteStatus = function (page) {
    this.progressStatus[page] = false;
  };

  this.getStatus = function () {
    return this.progressStatus;
  };

  this.reset = function () {
    this.progressStatus[this.cartPage] = false;
    this.progressStatus[this.shippingPage] = false;
    this.progressStatus[this.paymentPage] = false;
    this.progressStatus[this.reviewOrderpage] = false;
  };
}

App.service('ProgressStepperStore', ['$filter', ProgressStepperStore]);

App.run([
  'ProgressStepperStore',
  function (OrderStatusStore) {
    // eagerly initialize the store so that event listeners are registered
  }
]);
